<s1-input-label [label]="label" [grouped]="grouped" [styleClass]="styleClass">
  <label class="switch switch-lg m-0">
    <input type="checkbox" [formControl]="control" [attr.disabled]="readonly ? true : null" />
    <span></span>
  </label>
</s1-input-label>